import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bebf1cb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cont" }
const _hoisted_2 = { class: "sub-menu" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "top-course" }
const _hoisted_5 = { class: "jx-course" }
const _hoisted_6 = { class: "jx-tit" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "课程精选", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全部课程 ")
const _hoisted_9 = { class: "list-menu" }
const _hoisted_10 = { class: "sidebar" }
const _hoisted_11 = { class: "subject-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ztjx" }, "专题精选", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("全部专题 ")
const _hoisted_14 = { class: "subject-cont" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  class: "img-block",
  span: 8
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  class: "cont-block",
  span: 16
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_DoubleRightOutlined = _resolveComponent("DoubleRightOutlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.loading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["wrapper", _ctx.theme])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delicate, (menu, idx) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: menu.groupCode,
                  class: _normalizeClass({'active':menu.groupCode === _ctx.currentMenuCode}),
                  onClick: ($event: any) => (_ctx.changeCurrentMenu(menu.groupCode,idx))
                }, _toDisplayString(menu.groupName), 11, _hoisted_3))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Card, {
                gutter: 22,
                span: 8,
                courses: _ctx.currentCourses.slice(0,3),
                onJumpToCourse: _ctx.jumpToCourse
              }, null, 8, ["courses", "onJumpToCourse"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.jumpToAllCourse && _ctx.jumpToAllCourse(...args)))
                }, [
                  _hoisted_8,
                  _createVNode(_component_RightOutlined)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendCourses, (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "group-block",
                  key: group.groupCode
                }, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(group.groupName), 1),
                  _createVNode(_component_Card, {
                    gutter: 22,
                    span: 8,
                    courses: group.courses,
                    onJumpToCourse: _ctx.jumpToCourse
                  }, null, 8, ["courses", "onJumpToCourse"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", {
                class: "all-group-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.jumpToAllGroup && _ctx.jumpToAllGroup(...args)))
              }, [
                _hoisted_13,
                _createVNode(_component_RightOutlined)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subject, (block) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "subject-block",
                  key: block.groupCode
                }, [
                  _createVNode(_component_a_row, { class: "sub-tit" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 21,
                        class: "name"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(block.groupName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_col, {
                        span: 3,
                        class: "more",
                        onClick: ($event: any) => (_ctx.jumpToGroup(block.groupCode,block.groupName))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createVNode(_component_DoubleRightOutlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.courses.slice(0,3), (course) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "subject-item",
                      key: course.courseNo,
                      onClick: ($event: any) => (_ctx.jumpToCourse({courseNo: course.courseNo, lessonNo: course.lessonNo || course.chapterNo || course.subCourseNo}, block.groupName))
                    }, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("img", {
                          src: course.coverImage,
                          alt: ""
                        }, null, 8, _hoisted_18)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createTextVNode(_toDisplayString(_ctx.getName(course)), 1)
                        ])), [
                          [_directive_widthoverflowtitle, _ctx.getName(course)]
                        ]),
                        _createElementVNode("p", null, _toDisplayString(course.introduction), 1)
                      ])
                    ], 8, _hoisted_16))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}